<template>
  <div class="consultant-header">
    <div class="wrapper">
      <div class="info-first consultant-stat">
        <div class="user-info">
          <h1 class="name">{{ this.name }}</h1>
          <div class="second">
            <p class="designation">{{ this.email }}</p>
            <p class="organization">
              {{ this.phn }}
            </p>
          </div>
        </div>
        <div class="edit-button dropdown">
          <button class="btn btn-primary dropbtn" @click="toggle">
            <i class="fa fa-chevron-down" aria-hidden="true"></i>
            EDIT PROFILE
          </button>
          <div class="dropdown-content" id="d">
            <div class="hover btn-link" @click="changePassword">
              Change Password
            </div>
            <!-- <div class="hover btn-link" @click="changeBilling">
              {{ hasBilling ? "Edit" : "Add" }} Billing Address
              <strong style="color: red" v-if="!hasBilling">!</strong>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import moment from "moment";
import Alert from "sweetalert2";
export default {
  name: "userHeader",
  props: ["name", "phn", "email"],
  methods: {
    changeBilling() {
      Alert.fire({
        title: "Billing Address",
        html:
          `Address <input id="str-inp" class="swal2-input" placeholder="Address" type="text" value="${this.billingInfo.street}">` +
          `City <input id="cit-inp" class="swal2-input" placeholder="City" type="text" value="${this.billingInfo.city}">` +
          `Town/Post Office <input id="sta-inp" class="swal2-input" placeholder="Town/Post Office" type="text" value="${this.billingInfo.state}">` +
          `Postal Code <input id="zip-inp" class="swal2-input" placeholder="Postal Code" type="text" value="${this.billingInfo.zip}">`,
        focusConfirm: false,
        confirmButtonText: "Submit",
        preConfirm: () => {
          return [
            document.getElementById("str-inp").value,
            document.getElementById("cit-inp").value,
            document.getElementById("sta-inp").value,
            document.getElementById("zip-inp").value
          ];
        }
      }).then(res => {
        if (res.value[0] && res.value[1] && res.value[2] && res.value[3]) {
          if (this.hasBilling === true) {
            this.$upskill
              .updateBilling({
                street: res.value[0],
                city: res.value[1],
                state: res.value[2],
                zip: res.value[3]
              })
              .then(() => {
                this.SuccessAlert("Billing address updated successfully!");
              });
          } else {
            this.$upskill
              .addBilling({
                street: res.value[0],
                city: res.value[1],
                state: res.value[2],
                zip: res.value[3]
              })
              .then(() => {
                this.SuccessAlert("Billing address added successfully!");
              });
          }
        } else {
          this.ErrorAlert("All the fields are required");
        }
      });
    },
    changePassword() {
      Alert.fire({
        title: "Change Password",
        html:
          '<input id="p-inp" class="swal2-input" placeholder="New Password" type="password">' +
          '<input id="cp-inp" class="swal2-input" placeholder="Confirm New Password" type="password">',
        focusConfirm: false,
        preConfirm: () => {
          return [
            document.getElementById("p-inp").value,
            document.getElementById("cp-inp").value
          ];
        }
      }).then(res => {
        if (res.value[0] && res.value[1]) {
          if (res.value[0] !== res.value[1]) {
            this.ErrorAlert("Password doesn't match!");
          } else {
            this.$upskill
              .passwordChange({ password: res.value[0] })
              .then(() => {
                this.SuccessAlert("Password changed successfully!");
              })
              .catch(() => {
                this.ErrorAlert("Something went wrong! Try again later.");
              });
          }
        }
      });
    },
    toggle() {
      var tag = document.getElementById("d");
      tag.style.display = tag.style.display === "block" ? "none" : "block";
      // set as defaut oposite defaut active value in document
      // here defaut is set to block cause it is none in CSS
    }
  }
};
</script>

<style scope>
.consultant-header {
  margin-bottom: 0;
}
.wrapper {
  max-width: 1300px;
  margin: 0 auto;
}
.second {
  display: flex;
}
.second :nth-child(2) {
  margin-left: 5px;
}
.designation {
  padding-right: 1em;
}
.user-info h1 {
  text-align: left;
  font-family: "Open Sans";
  font-size: 48px;
  font-weight: 700;
  letter-spacing: -2.4px;
  color: #000000;
  opacity: 1;
}
.user-info p {
  text-align: left;
  font-family: "Open Sans";
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.8px;
  color: #000000;
  opacity: 1;
}
.consultant-stat {
  max-width: 1300px;
  margin: 0 auto;
}
.info-first {
  display: flex;
  justify-content: space-between;
  padding-left: 50px;
  padding-right: 56px;
  background-color: #ffffff;
  padding-top: 35px;
  padding-bottom: 40px;
  border-radius: 10px 10px 0 0;
}
.name {
  font-weight: 600;
}
.edit-button {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.btn-primary {
  width: 300px;
  font-family: "Montserrat", sans-serif;
}
.fa-chevron-down {
  padding-right: 1em;
}
.dropbtn {
  cursor: pointer;
}

.dropdown-content {
  display: none;
  /* position: absolute; */
  background-color: #f9f9f9;
  width: 100%;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  /* z-index: 1; */
}

.dropdown-content div {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  font-family: "Montserrat", sans-serif;
  text-align: center;
}

/* .dropdown-content a:target {background-color: #f1f1f1}

.dropdown:target .dropdown-content {
  display: block;
} */

.dropdown:hover .dropbtn {
  /* background-color: #3e8e41; */
}
@media only screen and (max-width: 600px) {
  .user-info h1 {
    text-align: center;

    font-size: 20px;

    letter-spacing: -1px;
  }
  .user-info p {
    text-align: center;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: 700;
    letter-spacing: -0.14px;
    color: #728391;
    opacity: 1;
  }
  .second {
    justify-content: center;
  }
  .info-first {
    display: flex;
    flex-direction: column;
    padding-left: 0px;
    padding-right: 0px;
    background-color: transparent;
    padding-top: 20px;
    padding-bottom: 30px;
    border-radius: 0;
  }
  .edit-button {
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
</style>
